import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  statusBar: true,
};

export const navBarSlice = createSlice({
  name: 'navBar',
  initialState,
  reducers: {
    changeNavBar: (state) => {
      state.statusBar = !state.statusBar;
    },
    navBarmobileOffStart: (state) => {
      state.statusBar = false;
    },
  },
});

export const { changeNavBar, navBarmobileOffStart } = navBarSlice.actions;
export default navBarSlice.reducer;
